export const PUBLIC_HOLIDAYS_URL =
	'https://canada-holidays.ca/api/v1/provinces/QC'
